// 2022 Topps Star Wars: The Book of Boba Fett — authored by hand (2026-09-18,
// collector-requested)
// =============================================================================
// SOURCES: official Topps checklist PDF + sell sheet (via GTS Distribution),
// TCDB (sid 306288 + per-insert sids), Cardboard Connection, Hero Habit, and
// Blowout's product solicitation — plus eBay/COMC specimens for every dispute.
//
// ⚠️ THE BASE NUMBERING SAGA (read before "fixing" anything here): the official
// Topps PDF lists the 100 base cards in a DIFFERENT order for cards 1-57 than
// the printed cards (PDF #1 is "Mayor Mok Shaiz's Majordomo"). A physical
// specimen settled it: the real base card #1 back reads "RECOVERING IN THE
// BACTA TANK" (eBay 235246350788, back photo read directly), and #34 "The
// Pyke Defense" is specimen-confirmed too. The printed order below is TCDB's,
// which fixes the sell sheet's two defects (a duplicated #34 and a missing
// #37 "Boba Fett's Vision"). Hero Habit's base list follows the PDF order —
// per HH the METAL VARIATION cards carry their own MV-prefixed numbering in
// that other sequence; TCDB catalogs Metal as a plain same-number parallel.
// Unresolved which is physically right for Metal, but CK models Metal as a
// parallel by card identity, so it doesn't matter here.
//
// Topps' own typos are preserved as printed and double-sourced: #8 "A Wookie
// Pelt Offering" (one e; TCDB + CC agree) vs #27 "The Intimidating Wookiee,
// Krrsantan". #90's card FRONT misspells the name "Krssantan" (TCDB UER note);
// the checklist title is correct and used here.
//
// BASE PARALLELS: Blue (1 per pack unless replaced) and Purple (1:4) are
// unnumbered; Red /99, Green /75, Bronze /50, Silver /25, Gold /10, Black 1/1,
// and the hobby-exclusive Metal Variation 1/1. Printing plates exist for base,
// inserts and autographs; CK does not track plates (site-wide convention).
//
// INSERTS: the official name of the C- insert is "Heroes & Villains" (Topps
// sell sheet + TCDB; CC and Hero Habit call it "Characters"). All four inserts
// share the Red /99 → Black 1/1 ladder (sell sheet + CC + TCDB agree).
//
// AUTOGRAPHS: 21 on-card signers with Topps-printed A-XX codes (A-CB1's "1" is
// as printed). Base autos are unnumbered (unserialed eBay specimens); ladder
// Red /99, Green /75, Bronze /50, Silver /25, Gold /10, Black 1/1. eBay titles
// calling a /50 auto "Gold" are seller errors — /50 is Bronze (TCDB + sell
// sheet + CC agree; Gold is /10).
//
// TODO (rule 7): DUAL (5, sticker) and TRIPLE (1) autographs — Cardboard
// Connection says the bases are serial numbered, but NO source states the run
// and no serialed base specimen surfaced (TCDB carries no SN tag; the sell
// sheet lists only the Gold /10 / Black 1/1 parallels). No blank-name serial
// slot is added because inventing a run would be worse than missing one; add
// the slot the day a specimen shows the base run. Odds: duals 1:832, triple
// 1:12,350.
//
// RELICS: Commemorative Patch MP-1..20 (TCDB's name; CC calls them
// Manufactured Medallions; sold 1 per Value Blaster, base unnumbered, eBay
// specimens) with the Red /99 → Black 1/1 ladder per TCDB + CC. Prop Relics
// PR-1..5 and hobby-only Sourced Fabric Relics FR-1..3 have NO unnumbered
// version — the entry tiers are Silver /25 (props; eBay PR-1 Silver /25
// specimen) and Bronze /50 (fabrics), so the serialed tiers below ARE the
// complete card, not chase parallels on a base.
//
// SKETCHES: standard (1:38) and Boba Fett helmet-shaped (1:372) sketch cards
// exist, but no artist roster is published anywhere (TCDB has no sketch set;
// the Topps checklist names no artists). Omitted until a roster surfaces —
// do not add a rosterless sketch sub-set.
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "purple", name: "Purple", print_run: null, color: "#b388ff" },
        { id: "red", name: "Red", print_run: 99, color: "#ff1744" },
        { id: "green", name: "Green", print_run: 75, color: "#00e676" },
        { id: "bronze", name: "Bronze", print_run: 50, color: "#d4a855" },
        { id: "silver", name: "Silver", print_run: 25, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
        { id: "metal-variation", name: "Metal Variation", print_run: 1, color: "#9aa7c0" },
      ],
    cards: [
        { n: "1", name: "Recovering in the Bacta Tank" },
        { n: "2", name: "Young Boba Fett in the Aftermath of Battle" },
        { n: "3", name: "Emergence from the Sarlacc Pit" },
        { n: "4", name: "Boba Fett Dragged Through the Desert" },
        { n: "5", name: "Imprisoned by Tuskens!" },
        { n: "6", name: "Taunted by the Tusken Child" },
        { n: "7", name: "Fennec Shand and Boba Fett Hold Court" },
        { n: "8", name: "A Wookie Pelt Offering" },
        { n: "9", name: "8D8" },
        { n: "10", name: "Mayor Mok Shaiz's Majordomo" },
        { n: "11", name: "The Gamorreans Meet Their New Master" },
        { n: "12", name: "Surveying Garsa's Sanctuary" },
        { n: "13", name: "Meeting Garsa Fwip" },
        { n: "14", name: "The Order of the Night Wind Revealed" },
        { n: "15", name: "Boba Fett Surrounded!" },
        { n: "16", name: "Cornered on the Rooftops" },
        { n: "17", name: "Fennec Shand at the Ready" },
        { n: "18", name: "Digging for Black Melons" },
        { n: "19", name: "A Fearsome Tatooine Sand Ape!" },
        { n: "20", name: "Boba Fett on the Offensive" },
        { n: "21", name: "A Trophy from Battle" },
        { n: "22", name: "A Gesture of Respect" },
        { n: "23", name: "Dealing with the Order of the Night Wind Assassin" },
        { n: "24", name: "The Mayor's Chambers" },
        { n: "25", name: "Bad News at Garsa's Sanctuary" },
        { n: "26", name: "Laying Claim to Jabba's Legacy" },
        { n: "27", name: "The Intimidating Wookiee, Krrsantan" },
        { n: "28", name: "Trouble Brewing at Tosche Station" },
        { n: "29", name: "Skills of the Bounty Hunter" },
        { n: "30", name: "A Stunning Aftermath" },
        { n: "31", name: "One More to Go" },
        { n: "32", name: "Newly Acquired Speeder Bikes" },
        { n: "33", name: "Closing in on the Train" },
        { n: "34", name: "The Pyke Defense" },
        { n: "35", name: "Engaging the Overdrive" },
        { n: "36", name: "Disabling the Hovertrain's Controls" },
        { n: "37", name: "Boba Fett's Vision" },
        { n: "38", name: "A Gift of Gratitude" },
        { n: "39", name: "Boba Fett Relives His Struggle in the Sarlacc Pit" },
        { n: "40", name: "Boba Fett's Final Step" },
        { n: "41", name: "8D8's Briefing" },
        { n: "42", name: "The Water Monger, Lortha Peel" },
        { n: "43", name: "Drash, Skad and Their Gang" },
        { n: "44", name: "Boba Fett Atop His Bantha" },
        { n: "45", name: "The Tusken Clan Laid to Rest" },
        { n: "46", name: "Krrsantan's Assassination Attempt" },
        { n: "47", name: "A Rancor Gift from the Twins" },
        { n: "48", name: "Boba Fett Bonds with His New Rancor" },
        { n: "49", name: "The Majordomo Flees in His Landspeeder" },
        { n: "50", name: "Drash in Pursuit" },
        { n: "51", name: "Skad Keeping Tabs on the Pyke Arrival" },
        { n: "52", name: "Boba Fett Seeks Help for Fennec Shand" },
        { n: "53", name: "The Modifier Gets to Work" },
        { n: "54", name: "Fennec Shand Recovers from Her Injuries" },
        { n: "55", name: "Planning Their Attack on Jabba's Palace" },
        { n: "56", name: "Taking Out the Chef Droid" },
        { n: "57", name: "Boba Fett's Starship Rains Down Fire!" },
        { n: "58", name: "Interrogating the LEP Droid" },
        { n: "59", name: "The Remnants of Jabba's Sail Barge" },
        { n: "60", name: "Unleashing the Seismic Charge" },
        { n: "61", name: "New Allies" },
        { n: "62", name: "The Local Crime Bosses of Tatooine" },
        { n: "63", name: "The Mandalorian on the Hunt" },
        { n: "64", name: "The Armorer in Exile" },
        { n: "65", name: "Reforging the Beskar Spear" },
        { n: "66", name: "The Night of a Thousand Tears" },
        { n: "67", name: "Duel with Paz Vizsla" },
        { n: "68", name: "A Gift for Grogu" },
        { n: "69", name: "The Mandalorian's New N-1 Starfighter" },
        { n: "70", name: "Flight Test" },
        { n: "71", name: "Run-in with the New Republic Fighters" },
        { n: "72", name: "Cobb Vanth on Patrol" },
        { n: "73", name: "A Chest Full of Spice" },
        { n: "74", name: "Grogu's Meditation Session with Luke Skywalker" },
        { n: "75", name: "Displaying the Power of the Jedi" },
        { n: "76", name: "Visions from Grogu's Troubling Past" },
        { n: "77", name: "Ahsoka Tano" },
        { n: "78", name: "Luke Skywalker with Grogu in Tow" },
        { n: "79", name: "Grogu's Balancing Act" },
        { n: "80", name: "Putting Grogu's Reflexes to the Test" },
        { n: "81", name: "Luke Skywalker and Ahsoka Tano Ponder Grogu's Fate" },
        { n: "82", name: "Boba Fett Briefs His Crew on the Pyke Threat" },
        { n: "83", name: "Cobb Vanth and the Mandalorian" },
        { n: "84", name: "The Return of Cad Bane" },
        { n: "85", name: "Explosion at the Sanctuary!" },
        { n: "86", name: "Grogu's Choice" },
        { n: "87", name: "The Mods, Skad and Drash" },
        { n: "88", name: "Standoff with Cad Bane" },
        { n: "89", name: "Skad and Drash" },
        { n: "90", name: "Krrsantan Takes Aim!" },
        { n: "91", name: "Taking on the Scorpenek Droid!" },
        { n: "92", name: "Boba Fett and His Rancor Stare Down Cad Bane" },
        { n: "93", name: "The Final Duel" },
        { n: "94", name: "Cad Bane Vanquished!" },
        { n: "95", name: "The Mandalorian Caught in the Rancor's Grasp!" },
        { n: "96", name: "Grogu Calms the Rancor" },
        { n: "97", name: "The Pyke Leader Under Attack" },
        { n: "98", name: "Grogu Peers From His Cockpit" },
        { n: "99", name: "Cobb Vanth Recovers in the Bacta Tank" },
        { n: "100", name: "The Gang of Youths Outside City Hall" },
    ],
  },
  {
    id: "heroes-villains",
    type: "insert",
    title: "HEROES & VILLAINS",
    parallels: [
        { id: "red", name: "Red", print_run: 99, color: "#ff1744" },
        { id: "bronze", name: "Bronze", print_run: 50, color: "#d4a855" },
        { id: "silver", name: "Silver", print_run: 25, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
      ],
    cards: [
        { n: "C-1", name: "Garsa Fwip" },
        { n: "C-2", name: "Boba Fett" },
        { n: "C-3", name: "Fennec Shand" },
        { n: "C-4", name: "Twi'lek Majordomo" },
        { n: "C-5", name: "Drash" },
        { n: "C-6", name: "Skad" },
        { n: "C-7", name: "The Mandalorian" },
        { n: "C-8", name: "Grogu" },
        { n: "C-9", name: "The Modifier" },
        { n: "C-10", name: "The Twins" },
        { n: "C-11", name: "Krrsantan" },
        { n: "C-12", name: "Ahsoka Tano" },
        { n: "C-13", name: "Cad Bane" },
        { n: "C-14", name: "Tusken Warrior" },
        { n: "C-15", name: "Tusken Chief" },
    ],
  },
  {
    id: "concept-art",
    type: "insert",
    title: "CONCEPT ART",
    parallels: [
        { id: "red", name: "Red", print_run: 99, color: "#ff1744" },
        { id: "bronze", name: "Bronze", print_run: 50, color: "#d4a855" },
        { id: "silver", name: "Silver", print_run: 25, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
      ],
    cards: [
        { n: "CA-1", name: "Fennec Shand's Rooftop Pursuit" },
        { n: "CA-2", name: "Boba Fett vs. The Sand Ape" },
        { n: "CA-3", name: "The Twins Arrive on Their Litter" },
        { n: "CA-4", name: "With the Tusken Clan" },
        { n: "CA-5", name: "Krrsantan" },
        { n: "CA-6", name: "Boba Fett's New Rancor" },
        { n: "CA-7", name: "Raining Down on the Kintan Striders Gang" },
        { n: "CA-8", name: "Taking Down the Sarlacc" },
        { n: "CA-9", name: "The Mandalorian" },
        { n: "CA-10", name: "The Glavis Ringworld" },
        { n: "CA-11", name: "A Stranger Approaches" },
        { n: "CA-12", name: "Mandalorian or Jedi?" },
        { n: "CA-13", name: "Rancor on the Loose" },
        { n: "CA-14", name: "Grogu's Arrival" },
        { n: "CA-15", name: "Boba Fett Bests Cad Bane" },
    ],
  },
  {
    id: "aliens-creatures",
    type: "insert",
    title: "ALIENS & CREATURES",
    parallels: [
        { id: "red", name: "Red", print_run: 99, color: "#ff1744" },
        { id: "bronze", name: "Bronze", print_run: 50, color: "#d4a855" },
        { id: "silver", name: "Silver", print_run: 25, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
      ],
    cards: [
        { n: "AC-1", name: "Tatooine Sand Ape" },
        { n: "AC-2", name: "Womprat" },
        { n: "AC-3", name: "Worrt" },
        { n: "AC-4", name: "Rancor" },
        { n: "AC-5", name: "Gamorrean" },
        { n: "AC-6", name: "Pyke" },
        { n: "AC-7", name: "Trandoshan" },
        { n: "AC-8", name: "Klatooinian" },
        { n: "AC-9", name: "Aqualish" },
        { n: "AC-10", name: "Nikto" },
    ],
  },
  {
    id: "boba-fetts-arsenal",
    type: "insert",
    title: "BOBA FETT'S ARSENAL",
    parallels: [
        { id: "red", name: "Red", print_run: 99, color: "#ff1744" },
        { id: "bronze", name: "Bronze", print_run: 50, color: "#d4a855" },
        { id: "silver", name: "Silver", print_run: 25, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
      ],
    cards: [
        { n: "BA-1", name: "Mandalorian Armor" },
        { n: "BA-2", name: "Z-6 Jetpack" },
        { n: "BA-3", name: "Flame Projector" },
        { n: "BA-4", name: "Gaderffii Stick" },
        { n: "BA-5", name: "Seismic Charge" },
        { n: "BA-6", name: "MM9 Mini Rocket Launcher" },
        { n: "BA-7", name: "Kneepad Rocket Dart Launcher" },
        { n: "BA-8", name: "Rancor" },
        { n: "BA-9", name: "EE-3 Carbine Rifle" },
        { n: "BA-10", name: "Tusken Cycler Rifle" },
    ],
  },
  {
    id: "autograph-cards",
    type: "auto",
    title: "AUTOGRAPHS",
    parallels: [
        { id: "red", name: "Red", print_run: 99, color: "#ff1744" },
        { id: "green", name: "Green", print_run: 75, color: "#00e676" },
        { id: "bronze", name: "Bronze", print_run: 50, color: "#d4a855" },
        { id: "silver", name: "Silver", print_run: 25, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
      ],
    cards: [
        { n: "A-AB", name: "Andrea Bartlow", artist: "Twi'lek Server" },
        { n: "A-AG", name: "Allan Graf", artist: "Bartender" },
        { n: "A-AH", name: "Alfred Hsing", artist: "Pyke Traveler" },
        { n: "A-AS", name: "Amy Sedaris", artist: "Peli Motto" },
        { n: "A-BL", name: "Barry Lowin", artist: "Garfalaquox" },
        { n: "A-CB1", name: "Chris Bartlett", artist: "UK2-B" },
        { n: "A-CJ", name: "Carey Jones", artist: "Krrsantan" },
        { n: "A-DK", name: "Dorian Kingi", artist: "Cad Bane" },
        { n: "A-DP", name: "David Pasquesi", artist: "Twi'lek Majordomo" },
        { n: "A-ES", name: "Emily Swallow", artist: "The Armorer" },
        { n: "A-JR", name: "John Rosengrant", artist: "Mayor Mok Shaiz" },
        { n: "A-LS", name: "Leilani Shiu", artist: "Jawa" },
        { n: "A-MB", name: "Matt Berry", artist: "8D8" },
        { n: "A-MPM", name: "Murphy Patrick Martin", artist: "Drummer" },
        { n: "A-MW", name: "Ming-Na Wen", artist: "Fennec Shand" },
        { n: "A-PL", name: "Phil LaMarr", artist: "Klatooinian Boss" },
        { n: "A-PSL", name: "Paul Sun-Hyung Lee", artist: "Carson Teva" },
        { n: "A-RD", name: "Rosario Dawson", artist: "Ahsoka Tano" },
        { n: "A-SK", name: "Skyler Bible", artist: "Fixer" },
        { n: "A-TM", name: "Temuera Morrison", artist: "Boba Fett" },
        { n: "A-WEB", name: "W. Earl Brown", artist: "Weequay Proprietor" },
    ],
  },
  {
    id: "dual-autographs",
    type: "auto",
    title: "DUAL AUTOGRAPHS",
    parallels: [
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
      ],
    cards: [
        { n: "DA-JM", name: "Temuera Morrison / Carey Jones", artist: "Boba Fett / Krrsantan" },
        { n: "DA-JMA", name: "Murphy Patrick Martin / Carey Jones", artist: "Drummer / Krrsantan" },
        { n: "DA-JW", name: "Carey Jones / Ming-Na Wen", artist: "Krrsantan / Fennec Shand" },
        { n: "DA-MK", name: "Dorian Kingi / Temuera Morrison", artist: "Cad Bane / Boba Fett" },
        { n: "DA-MW", name: "Ming-Na Wen / Temuera Morrison", artist: "Fennec Shand / Boba Fett" },
    ],
  },
  {
    id: "triple-autographs",
    type: "auto",
    title: "TRIPLE AUTOGRAPHS",
    parallels: [
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
      ],
    cards: [
        { n: "TA-PMW", name: "Ming-Na Wen / Temuera Morrison / David Pasquesi", artist: "Fennec Shand / Boba Fett / Twi'lek Majordomo" },
    ],
  },
  {
    id: "commemorative-patch",
    type: "insert",
    title: "COMMEMORATIVE PATCH CARDS",
    parallels: [
        { id: "red", name: "Red", print_run: 99, color: "#ff1744" },
        { id: "bronze", name: "Bronze", print_run: 50, color: "#d4a855" },
        { id: "silver", name: "Silver", print_run: 25, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
      ],
    cards: [
        { n: "MP-1", name: "Boba Fett" },
        { n: "MP-2", name: "Boba Fett" },
        { n: "MP-3", name: "Boba Fett" },
        { n: "MP-4", name: "Boba Fett" },
        { n: "MP-5", name: "Boba Fett" },
        { n: "MP-6", name: "Boba Fett" },
        { n: "MP-7", name: "Boba Fett" },
        { n: "MP-8", name: "Boba Fett" },
        { n: "MP-9", name: "Boba Fett" },
        { n: "MP-10", name: "Boba Fett" },
        { n: "MP-11", name: "Fennec Shand" },
        { n: "MP-12", name: "Fennec Shand" },
        { n: "MP-13", name: "Fennec Shand" },
        { n: "MP-14", name: "Fennec Shand" },
        { n: "MP-15", name: "Fennec Shand" },
        { n: "MP-16", name: "Fennec Shand" },
        { n: "MP-17", name: "Fennec Shand" },
        { n: "MP-18", name: "Fennec Shand" },
        { n: "MP-19", name: "Fennec Shand" },
        { n: "MP-20", name: "Fennec Shand" },
    ],
  },
  {
    id: "prop-relics",
    type: "insert",
    title: "PROP RELICS",
    parallels: [
        { id: "silver", name: "Silver", print_run: 25, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
      ],
    cards: [
        { n: "PR-1", name: "Boba Fett" },
        { n: "PR-2", name: "Fennec Shand" },
        { n: "PR-3", name: "Twi'lek Majordomo" },
        { n: "PR-4", name: "Drash" },
        { n: "PR-5", name: "Skad" },
    ],
  },
  {
    id: "sourced-fabric-relics",
    type: "insert",
    title: "SOURCED FABRIC RELICS",
    parallels: [
        { id: "bronze", name: "Bronze", print_run: 50, color: "#d4a855" },
        { id: "silver", name: "Silver", print_run: 25, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "black", name: "Black", print_run: 1, color: "#a8a8b4" },
      ],
    cards: [
        { n: "FR-1", name: "Rancor Keeper" },
        { n: "FR-2", name: "Fennec Shand" },
        { n: "FR-3", name: "The Armorer" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
